import uuid from 'uuid';

import isEmpty from 'lodash/isEmpty';
import {
  DUPLICATE_TEMPLATE_NAME_MESSAGE,
  INVALID_TEMPLATE_NAME_MESSAGE,
  MULTI_WORD_TEMPLATE_NAME_MESSAGE,
} from '../constants/messages';

export const isTemplateNameUnique = (templateName, templateList) => {
  if (isEmpty(templateList)) {
    return false;
  }
  return !templateList?.some(template => template.messageTemplateName === templateName);
};

export const templateNameValidator = (templateName, templateList) => {
  if (isEmpty(templateName) || isEmpty(templateName?.trim())) {
    return {
      isValidTemplateName: false,
      message: INVALID_TEMPLATE_NAME_MESSAGE,
    };
  }

  if (templateName?.split(' ')?.length > 1) {
    return {
      isValidTemplateName: false,
      message: MULTI_WORD_TEMPLATE_NAME_MESSAGE,
    };
  }

  if (!isTemplateNameUnique(templateName, templateList)) {
    return {
      isValidTemplateName: false,
      message: DUPLICATE_TEMPLATE_NAME_MESSAGE,
    };
  }

  return {
    isValidTemplateName: true,
    message: '',
  };
};

export const addImageSection = ({ source, height = 384, width = 512 }) => {
  const element = {
    id: uuid.v4(),
    type: 'image',
    content: `<img async src="${source}" height="${height}" width="${width}" />`,
  };
  return element;
};
